import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_AUTHORIZATION_SUBMISSION' as const;
export { ExportStatus as Status };
